import routes from 'sitewide-js/core_pre_webpack/routes';
import { fetchWithCsrf } from 'js/utils';
import { currentUser } from 'js/utils/user';
import { BulkDownloadFile } from 'js/bulk_download/bulk_download_helper';

type recordBulkDownloadParams = {
  work_id: string;
  files: BulkDownloadFile[];
  user_id?: number;
  download_type?: string;
};

export const recordBulkDownload = ({
  user_id = currentUser?.id,
  work_id,
  files,
  download_type = 'server-side',
}: recordBulkDownloadParams): void => {
  fetchWithCsrf(
    routes.api_v0_bulk_downloads_downloads_path({ subdomain_param: 'api' }),
    {
      method: 'POST',
      body: JSON.stringify({ user_id, work_id, files, download_type }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};
